const GROWTH_EVENTS_API_ENDPOINT =
  'https://www.spotify.com/api/growth-events/wwwanalyticsagnostic';

const EVENT_ACTION = 'click';
export const EVENT_CATEGORY = 'masthead';
export const EVENT_CATEGORY_FOOTER = 'masthead-footer';

const ActionAttribute = {
  Download: 'download',
  Free: 'free',
  LogIn: 'log-in',
  Play: 'play',
  Premium: 'premium',
  SignUp: 'sign-up',
};

const Label = {
  Download: 'download',
  Login: 'login',
  OpenWebPlayer: 'open_web_player',
  Premium: 'premium',
  Signup: 'signup',
};

const EventLabels = {
  [ActionAttribute.Download]: Label.Download,
  [ActionAttribute.Free]: Label.Download,
  [ActionAttribute.LogIn]: Label.Login,
  [ActionAttribute.Play]: Label.OpenWebPlayer,
  [ActionAttribute.Premium]: Label.Premium,
  [ActionAttribute.SignUp]: Label.Signup,
};

function isValidGaAction(gaAction) {
  return gaAction in EventLabels;
}

function isSendBeaconSupported() {
  return 'sendBeacon' in window.navigator;
}

const logClickEvent = (category = EVENT_CATEGORY) => ({
  target: { dataset, href },
}) => {
  if (!isValidGaAction(dataset.gaAction) || !isSendBeaconSupported()) return;

  window.navigator.sendBeacon(
    GROWTH_EVENTS_API_ENDPOINT,
    JSON.stringify({
      action: EVENT_ACTION,
      category,
      destination_url: href,
      label: EventLabels[dataset.gaAction],
      context: `${window.location}`,
    }),
  );
};

export const logClickEventFooter = logClickEvent(EVENT_CATEGORY_FOOTER);

export default logClickEvent(EVENT_CATEGORY);
